module.exports = __webpack_public_path__ + "img/translate-nine.3e8ee18f.png";